<template>
  <div>
    <login-component @token="login($event)" v-if="!localStorage.token"></login-component>

    <b-container fluid v-else>
      <b-button v-b-toggle.sidebar-1 class="float-left mt-n5"
        ><b-icon-justify></b-icon-justify
      ></b-button>
      <b-button @click="disconnect" class="float-right">Déconnexion</b-button>

      <div v-if="THAudits">
        <h4>THAudits</h4>

        <b-tabs align="center">
          <b-tab title="Ballons">
            <ballon-management />
          </b-tab>
          <b-tab title="Capteurs">
            <capteur-management />
          </b-tab>
          <b-tab no-body title="Composants">
            <composants-component />
          </b-tab>

          <b-tab title="Caractéristiques">
            <characteristics-management />
          </b-tab>
          <b-tab title="Vérifications" active>
            <verifications-table :isDisconnected="isDisconnected" />
          </b-tab>
          <b-tab title="Rapports">
            <reports-component />
          </b-tab>
          <b-tab title="Utilisateurs">
            <user-management />
          </b-tab>
        </b-tabs>
      </div>
      <div v-if="mapgisol">
        <h4>mapGiSOL</h4>
        <InstallationsManagement />
      </div>
    </b-container>
    <b-sidebar id="sidebar-1" visible title="" shadow backdrop>
      <div class="px-3 py-2">

         <b-button variant="info" block @click="THAudits = true">THAudits</b-button>
         <b-button variant="info" block @click="goToTHAuditsStats()">THAudits statistiques</b-button>
         <b-button variant="info" block @click="mapgisol = true">mapGiSOL</b-button>
         <b-button variant="info" block href="https://thmes.jcloud-ver-jpe.ik-server.com">THmes</b-button>


        <!-- <b-img
          src="https://picsum.photos/500/500/?image=54"
          fluid
          thumbnail
        ></b-img> -->
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import VerificationsTable from "./VerificationsTable.vue";
import UserManagement from "./UserManagement.vue";
import CharacteristicsManagement from "./CharacteristicsManagement.vue";
import ReportsComponent from "./ReportsComponent.vue";
import LoginComponent from "./LoginComponent.vue";
import ComposantsComponent from "./ComposantsComponent.vue";
import BallonManagement from "./BallonManagement.vue";
import CapteurManagement from "./CapteurManagement.vue";
import InstallationsManagement from "./reseauxChaleurs/InstallationsManagement.vue";

export default {
  components: {
    VerificationsTable,
    UserManagement,
    CharacteristicsManagement,
    ReportsComponent,
    LoginComponent,
    ComposantsComponent,
    BallonManagement,
    CapteurManagement,
    InstallationsManagement
  },
  data: function() {
    return {
      showUserManagement: false,
      showComponentsManagement: true,
      showCaracteristicsManagement: false,
      isDisconnected: false,
      showReportsComponent: false,
      showComposantsComponent: false,
      token: "",
      mapgisol: false,
      THAudits: true,
    };
  },
  watch: {
     token() {
      this.token = this.localStorage.token
    },
    mapgisol(newValue) {
      if (newValue === true) {
        this.THAudits = false;
      }
    },
    THAudits(newValue) {
      if (newValue === true) {
        this.mapgisol = false;
      }
    },
  },
  mounted() {
    if (this.localStorage.token) {
      this.token = this.localStorage.token;
    }
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('app') === "mapgisol") {
        this.mapgisol = true;
      }

  },
  methods: {
    goToTHAuditsStats() {
      // console.log(process.env.VUE_APP_PLATFORM_BASE_URL);
      // window.open("http://localhost:8000?token="+this.token)
      // window.open(process.env.VUE_APP_API_BASE_URL+'/platform?token='+this.token)
      console.log(process.env);
      process.env.VUE_APP_PLATFORM_BASE_URL
      window.open(process.env.VUE_APP_PLATFORM_BASE_URL+'?token='+this.token)
    },
    disconnect() {
      // this.showComponent();
          this.localStorage.token = null;
      this.localStorage.user = null;
      this.token = null;
      this.isDisconnected = true;
    },
    login(token) {
      this.token = token;
    },
  },
};
</script>

<style>
.custom_navbar {
  margin-top: -60px;
}

/* .active {
  color: #ffffff !important;
} */

.round_corner {
  border-radius: 8px;
  /* margin: 20px; */
}
</style>
